import HeroLanding from "../../components/HeroLanding";
import videoDesktop from '../../assets/landing/landingFisio/fisio-page-mcare.webm';
import ContactModal from "../../components/ContactModal";
import videoMobile from '../../assets/landing/landingFisio/fisio-landing-mobile.webm';
import { useState } from "react";
import Reviews from "../../components/Reviews";
import reviewsBackground from '../../assets/recensioni_mcare.webp';
import Minimal from "../../components/Minimal";
import mCareSede from '../../assets/azienda/sede-mcare.png';
import { FaLocationDot } from "react-icons/fa6";
import { Link, useNavigate } from "react-router-dom";
import ContactForm from "../../components/contactForm/ContactForm";
import logoUniversita from '../../assets/logo/logoUniversita.png';
import DoubleImageText from "../../components/DoubleImageText";
import fasciaGinocchio from '../../assets/landing/landingFisio/C1794T01.JPG';
import gambe from '../../assets/landing/landingFisio/C1777T01.JPG';
import calciatore from '../../assets/landing/landingFisio/calciatore.png';
import calciatore2 from '../../assets/landing/landingFisio/calciatore2.png';
import doloreSpalla from '../../assets/landing/landingFisio/3.jpg';
import camminare from '../../assets/landing/landingFisio/infortunio.jpg';
import ginocchio from '../../assets/landing/landingFisio/post-intervento.jpg';
import collo from '../../assets/landing/landingFisio/4.jpg';
import padel from '../../assets/landing/landingFisio/5.jpg';
import Percorso from "../../components/Percorso";
import MinimalSection from "../../components/MinimalSection";
import staff from '../../assets/landing/landingFisio/foto-staff.jpg';
import TextImage from "../../components/TextImage";
import dottDennis from '../../assets/staff/denis_romani.webp';
import terapiaGinocchio from '../../assets/landing/landingFisio/terapiaGinocchio.png';
import BookmarksSection from "../../components/BookmarksSection";
import movimento from '../../assets/landing/landingFisio/movimento2.png';

export default function LandingFisio() {

    const [contactModal, setContactModal] = useState(false);
    const navigate = useNavigate();

    const closeContactModal = () => {
        setContactModal(false);
    };
    const handleClick = () => {
        window.location.href = '#formContatti';
    };
    const goToStaff = () => {
        navigate('/staff');
    };

    const reviews = [
        {
            title: 'G.T.',
            stars: 5,
            text: 'Mi sono rivolto ad Mcare a seguito di una grave lussazione di spalla causata in moto. Mi hanno fatto sentire fin da subito a mio agio, Paolo, Luca e tutti i ragazzi del team. Dopo due/tre mesi sono tornato in forma al 100% nonostante il recupero sembrava più difficoltoso. Sono stato seguito in maniera super accurata e mi ritengo molto fortunato di aver svolto la riabilitazione con loro.'
        },
        {
            title: 'A.G.',
            stars: 5,
            text: 'In terapia da 6 mesi, pre e post intervento legamento crociato. Una famiglia che ti accoglie e ti segue in tutte le fasi con grande professionalità, umanità e disponibilità. Grazie!'
        },
        {
            title: 'E.L.',
            stars: 5,
            text: 'Centro di riabilitazione nuovo, personale molto accogliente! sono stato seguito dalla fisioterapista Anna che ha fatto un ottimo lavoro e mi ha dato tanti utili consigli. Assolutamente consigliato!'
        },
        {
            title: 'D.Q.',
            stars: 5,
            text: 'Mi hanno consigliato questo centro più per la comodità data la vicinanza all’inizio, ma sono felice di aver scoperto che sono specializzati nello sport. Fisioterapista competente e disponibile. La clinica è nuovissima e ben attrezzata, molto comodo anche l’ampio parcheggio e il fatto che sia proprio all’uscita dell’autostrada Verona sud. Consigliatissimo'
        },
        {
            title: 'R.P.',
            stars: 5,
            text: 'Problemi alla colonna vertebrale che altrove non sono riuscito a curare in maniera efficace. Qui grazie alla professionalità di Luca e Paolo, sto decisamente meglio dopo poche sedute. Bravi e grazie!!'
        },
        {
            title: 'P.P.',
            stars: 5,
            text: 'Professionalità, disponibilità e accoglienza hanno risolto il mio problema su una cicatrizzazione fastidiosa. Voto 10'
        },
        {
            title: 'G.P.',
            stars: 5,
            text: "Centro d'eccellenza sotto tutti i punti di vista. Dalla gentilezza delle segretarie alla competenza e cura dei fisioterapisti. Ti senti seguito passo dopo passo con grande professionalità."
        },
        {
            title: 'G.L.',
            stars: 5,
            text: "Professionisti aggiornati, preparati e disponibili. Fisioterapia all'avanguardia."
        },
    ];

    const doubleImageTextData = {
        title: "L’eccellenza universitaria incontra le più avanzate tecnologie per la tua salute",
        text: <div className="text-white text-lg text-center md:text-left">

            <p>
                Ci affidiamo a un <strong>metodo scientifico</strong> per farti recuperare movimento, forza, sicurezza e autonomia.
            </p>
            <p className="mt-4">
                Il nostro obiettivo e farti tornare alle attività che fanno parte della tua quotidianità: lavorare, camminare, riprendere un hobby o semplicemente sentirsi liberi in ogni gesto.
            </p>
        </div>

    };

    const doloreInfortuniData = {
        title: "Ogni percorso parte da una situazione diversa",
        subtitle: "Ogni situazione è differente e necessita un approccio dedicato e specifico.",
        images: [
            {
                src: doloreSpalla,
                alt: " uomo si tocca la spalla perché sente un particolare dolore",
                title: "dolore o limitazione",
                description: "Un fastidio che persiste o un movimento che non riesci più a fare come prima."
            },
            {
                src: camminare,
                alt: "paziente di Mcare cammina sul tapis roulant per recuperare da un infortunio",
                title: "dopo un infortunio",
                description: "Recuperare progressivamente mobilità, forza e funzione."
            },
            {
                src: ginocchio,
                alt: "paziente di Mcare lavora al centro di riabilitazione per recuperare da un intervento chirurgico al ginocchio",
                title: "dopo un intervento",
                description: "Un percorso riabilitativo costruite sulle diverse fasi del recupero post-intervento."
            },
            {
                src: collo,
                alt: "immagine che mostra un determinato tipo di dolore, in particolare sulla schiena",
                title: "problemi muscolo-scheletrici",
                description: "Schiena, cervicale, spalla, ginocchio, anca, caviglia e altre aree che possono limitare il movimento."
            },
            {
                src: padel,
                alt: "ragazza che torna a giocare a padel dopo la riabilitazione",
                title: "ritorno all’attività",
                description: "Quando l’obiettivo è riprendere lavoro, attività quotidiane, hobby o sport amatoriale."
            }
        ]
    };

    const bookmarksSectionData = {
        title: "Un percorso scelto da atleti e sportivi professionisti",
        image: terapiaGinocchio,
        alt: "fisioterapista di Mcare esegue una terapia al ginocchio di un paziente sportivo",
        steps: [
            {
                title: "Valutiamo",
                subtitle: "Partiamo dalla tua situazione, dai sintomi e dalle limitazioni che stai vivendo."
            },
            {
                title: "Definiamo l’obiettivo",
                subtitle: "Non soltanto “stare meglio”, ma capire concretamente cosa vuoi tornare a fare."
            },
            {
                title: "Costruiamo il percorso",
                subtitle: "Terapia, esercizio e tecnologie vengono inseriti in funzione delle tue necessità."
            },
            {
                title: "Misuriamo i progressi",
                subtitle: "Il percorso viene rivalutato nel tempo sfruttando le migliori tecnologie per capire come sta cambiando la tua condizione."
            },
            {
                title: "Recuperiamo il movimento",
                subtitle: "Fino al ritorno alle attività compatibili con la tua situazione e con gli obiettivi definiti."
            }
        ]
    };


    return (
        <main>
            <HeroLanding
                title="Torna a muoverti come vuoi"
                subtitle="Percorsi di fisioterapia per tornare a muoverti come prima."
                desktopVideoSrc={videoDesktop}
                mobileVideoSrc={videoMobile}
                handleClick={handleClick}
            />

            <div className="p-16">
                <div className="flex flex-col md:flex-row justify-center items-center gap-4">
                    <img src={logoUniversita} alt="Logo Università" className="md:w-44 md:h-44 w-24 h-24" data-aos="fade" />
                    <p className="text-white text-xl md:text-4xl font-bold md:w-1/2 text-center" data-aos="fade" data-aos-delay="400">Siamo Centro Universitario affiliato all’Università degli Studi di Verona</p>
                </div>
            </div>


            <DoubleImageText
                title={doubleImageTextData.title}
                description={doubleImageTextData.text}
                handleClick={handleClick}
            >
                <div className="relative flex items-center px-6 md:px-14 md:w-1/2">
                    <div className=" w-full">
                        <div className="w-full md:w-1/2 lg:w-2/5 md:ml-auto md:absolute md:left-28 lg:left-5 md:top-10">
                            <img src={fasciaGinocchio} alt="fisioterapista di Mcare tratta un paziente tramite l'utilizzo di fasce apposite" className="w-full rounded-md object-cover shadow-lg" />
                        </div>

                        <div className="w-full md:w-1/2 lg:w-2/5 mt-8 md:mt-0 md:absolute lg:right-40 md:bottom-4">
                            <img src={gambe} alt="paziente lavora sulla propria mobilità all'interno di uno dei centri di Mcare" className="w-full rounded-md object-cover shadow-lg" />
                        </div>
                    </div>
                </div>
            </DoubleImageText>

            <div className="py-16 bg-gradient-to-b from-[#75BDA2] to-[#497F6B]">
                <div className="flex flex-col md:flex-row justify-center items-center gap-14">
                    <img src={calciatore} alt="Ronaldo Pompeu Da Silva, calciatore professionista, calcia un pallone durante una partita di campionato" className="" />
                    <div className="text-white md:w-3/5 space-y-4 p-3 text-center md:text-left">
                        <h3 className="text-2xl md:text-4xl font-bold text-center md:text-left">Sportivi professionisti che ci hanno scelto</h3>
                        <p className="text-xl font-bold">Ronaldo Pompeu Da Silva</p>
                        <p className="text-lg font-semibold italic">Calciatore professionista</p>
                        <p className="text-lg">Grazie ai fisioterapisti di Mcare sono tornato in campo al massimo della forma dopo l’intervento di ricostruzione del legamento crociato anteriore.</p>
                    </div>
                </div>
            </div>

            <Percorso
                title={doloreInfortuniData.title}
                subtitle={doloreInfortuniData.subtitle}
                tags={[]}
                images={doloreInfortuniData.images}
            />

            <TextImage
                title="Un team multidisciplinare al tuo servizio"
                description={
                    <p className="text-white text-lg text-center md:text-right">
                        Fisioterapisti, osteopati, medici specialisti, psicologi e professionisti sanitari lavorano con un obiettivo comune: comprendere la situazione della persona e costruire un percorso coerente con le sue esigenze di recupero.
                    </p>
                }
                image={staff}
                alt="team multidisciplinare di professionisti Mcare"
                buttonText="Scopri il team"
                handleClick={goToStaff}
            />

            <div className=" bg-gradient-to-b from-[#75BDA2] to-[#497F6B] ">
                <div className="flex flex-col md:flex-row justify-center items-center md:gap-14">
                    <img src={dottDennis} alt="foto del dottor Denis Romani, direttore sanitario e medico chirurgo, specialista in ortopedia e traumatologia, membro dello staff di Mcare" className="md:h-[50vh]" />
                    <div className="text-white md:w-3/5 space-y-4 px-3 py-6 md:py-3 text-center md:text-left">
                        <p className="text-2xl font-bold">Dott. Denis Romani</p>
                        <p className="text-lg">Direttore Sanitario e Medico Chirurgo, specialista in Ortopedia e Traumatologia, con particolare esperienza nella traumatologia dell’arto superiore, del polso e della mano.</p>
                    </div>
                </div>
            </div>


            <BookmarksSection
                title={bookmarksSectionData.title}
                image={bookmarksSectionData.image}
                alt={bookmarksSectionData.alt}
                steps={bookmarksSectionData.steps}
            />

            <div className="py-16 bg-gradient-to-b from-[#75BDA2] to-[#497F6B]">
                <div className="flex flex-col md:flex-row justify-center items-center gap-14">
                    <img src={calciatore2} alt="Franco Ferrari, calciatore professionista, che festeggia dopo aver segnato una rete in campionato" className="h-full" />
                    <div className="text-white md:w-3/5 space-y-4 p-3 text-center md:text-left">
                        <h3 className="text-2xl md:text-4xl font-bold text-center md:text-left">Sportivi professionisti che ci hanno scelto</h3>
                        <p className="text-xl font-bold">Franco Ferrari</p>
                        <p className="text-lg font-semibold italic">Calciatore professionista</p>
                        <p className="text-lg">Centro top! <br />
                            Grazie alla professionalità dei fisioterapisti, ho recuperato alla grande dalla rottura del legamento crociato anteriore.</p>
                    </div>
                </div>
            </div>

            <TextImage
                orientation="left"
                title="Non serve essere un atleta per voler tornare a stare bene"
                description={
                    <>
                    <p className="text-white text-lg text-center md:text-left">
                        C'è chi vuole tornare in campo.
                        E chi vuole tornare a camminare senza dolore, lavorare senza sentirsi limitato, riprendere una passeggiata, andare in bicicletta o semplicemente affrontare meglio la propria giornata.
                    </p>
                    <p className="text-white text-lg  font-bold mt-5 text-center md:text-left">
                       Il movimento ha un significato diverso per ognuno. 
                    </p>
                    </>
                }
                overlay
                image={movimento}
                alt="team multidisciplinare di professionisti Mcare"
                buttonText="Prenota una visita"
                handleClick={handleClick}
            />

              {/* TESTIMONIANZE */}
      <div className="py-16 h-screen relative flex items-center justify-center">
        <img src={reviewsBackground} alt="Testimonianze" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black opacity-30"></div>
        <Reviews reviews={reviews} />
      </div>

      {/* SEDI */}
       <Minimal
                title="Dove ci trovi"
                image={mCareSede}
                alt
                imageMobileHidden={false}
                sideSection={false}
                containerWidth="w-full"
                extraClass="space-y-20"
                content={
                    <div className='grid md:grid-cols-2 grid-cols-1 place-content-center md:gap-24 gap-16 mx-4 md:mx-0'>
                        <div className='flex flex-col items-center gap-10'>
                            <FaLocationDot size={40} color="white" />
                            <Link to="https://maps.app.goo.gl/wqGkMEmPocxQ7DjXA" target="_blank" className='text-white underline-animate text-xl skip-ink-auto'>Via Enrico Fermi 13/A, 37135, Verona</Link>
                        </div>
                        <div className='flex flex-col items-center gap-1'>
                            <div className='flex flex-col items-center gap-10'>
                                <FaLocationDot size={40} color="white" />
                                <Link to="https://maps.app.goo.gl/xyPVjWf95XXx7KPA8" target="_blank" className='text-white underline-animate text-xl skip-ink-auto'>Via Toscana 13, 37060, Sona (VR)</Link>
                            </div>
                            {/* <p className='uppercase text-sm text-white italic bg-mcare-green py-1 px-2 rounded-sm mt-2'>Prossima apertura Settembre 2026</p> */}
                        </div>
                    </div>
                } />

            {/* sez. contatti */}
            <div className="grid grid-cols-4 gap-0" id='formContatti'>
                <div className="col-span-4 flex justify-center items-center py-32 bg-black">
                    <div className="w-full absolute z-0" style={{ "height": "120%" }}></div>
                    <div className='w-full lg:w-2/6 z-30 px-5'>
                        <p className='text-center text-4xl font-semibold mb-6 text-mcare-green panoragraf-light'>Prenota una visita</p>
                        <ContactForm
                            LandingName='mcare'
                            Name={true}
                            NameClass='text-slate-50'
                            NameText='Nome e Cognome:'
                            NameRequired={true}
                            Tel={true}
                            TelClass='text-slate-50'
                            TelText='Telefono:'
                            TelRequired={true}
                            Email={true}
                            EmailClass='text-slate-50'
                            EmailText='Email:'
                            EmailRequired={true}
                            Dropdown={true}
                            DropdownText="Scegli il centro:"
                            DropdownRequired={true}
                            DropdownItem={[' ', 'Mcare Verona', 'Mcare Sona']}
                            DropdownClass='text-slate-50'
                            ConsensoDati={true}
                            ConsensoDatiRequired={true}
                            ConsensoDatiText="Consenso dati"
                            ConsensoDatiID={1}
                            ConsensoDatiClass='text-slate-50'
                            successText='Messaggio inviato con successo!'
                            successLink='/'
                            errorText='Si è verificato un errore, Riprova!'
                            SendText='Invia'
                            SendClass='progress-button-mcare w-full '
                        />
                    </div>
                </div>
            </div>
            <ContactModal isContactModal={contactModal} closeModal={closeContactModal} />
        </main>
    );
}